import { useEffect } from 'react';
import { useStore } from 'stores';
import { getUserMarketProfile } from 'api/strategy';
import Content from 'components/Content';
import Footer from 'components/Footer';
import MainHeader from './MainHeader';
import Bottom from './Bottom';

/**
 * 主要內容
 */
function Main() {
  const isLogin = useStore((state) => state.isLogin);
  const currentEmail = useStore((state) => state.currentEmail); // 登入的 email
  const setUserMarketProfile = useStore((state) => state.setUserMarketProfile); // 自選策略清單

  useEffect(() => {
    async function fetch() {
      const res = await getUserMarketProfile(currentEmail);
      setUserMarketProfile(res);
    }
    if (isLogin && currentEmail.length > 0) {
      fetch();
    }
  }, [isLogin, currentEmail, setUserMarketProfile]);

  return (
    <div className="flex flex-col items-center mt-14">
      {!isLogin && <MainHeader />}

      <Content />

      {!isLogin && <Bottom />}

      <Footer />
    </div>
  );
}

export default Main;
